import { customScrollMinimal } from '@toggle/design-system';
import styled from 'styled-components';

export const InsightsListSectionRoot = styled.div`
  border-right: 2px solid var(--border-soft);
  overflow: auto;
  ${customScrollMinimal};
  height: 100%;
  width: 100%;
  min-width: 0;
  padding-left: 20px;
`;
